import { createFeatureSelector, createSelector } from '@ngrx/store';

import { getAccessibleSites } from '@domain/tenant/tenant-models.mappings';

import { TenantsState, tenantsFeatureKey } from './tenants.reducer';

export const selectTenantsFeature = createFeatureSelector<TenantsState>(tenantsFeatureKey);

export const selectTenants = createSelector(selectTenantsFeature, (state) => state.tenants);
export const selectAccessibleSites = createSelector(selectTenants, getAccessibleSites);
export const selectTenantsIsLoading = createSelector(selectTenantsFeature, (state) => state.isLoading);
export const selectTenantsError = createSelector(selectTenantsFeature, (state) => state.error);
export const selectTenantsHasResolved = createSelector(
  selectTenants,
  selectTenantsError,
  (tenants, error) => tenants !== undefined || error !== undefined
);
export const selectTenantsIsInitialLoading = createSelector(
  selectTenants,
  selectTenantsIsLoading,
  (tenants, isLoading) => tenants === undefined && isLoading
);
